import Swal from 'sweetalert2'
import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'
import { 
  sweetAlertCommonParams, 
  selectedOptionsTextArray,
  createSelect2DynamicOption,
  getNodeInputConnectionsBySocketName,
} from '../../utils/functions'

const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon

export const referenceModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.postback_modal_title,
    html:
      '<div class="form-group text-left mt-2">' +
        '<label for="reference-reference-postback">' + lang.postback_html_label_title + '</label>' +
        '<input type="text" id="reference-reference-postback" class="form-control">' +
      '</div>'+
      '<div class="form-group text-left mt-4">' +
        '<div class="d-flex justify-content-between">' +
          '<label for="reference-choose-label">' + lang.postback_html_label_label + '</label>' +
          '<span class="text-small text-primary text-underline" data-toggle="tooltip" data-original-title="' + lang.postback_html_label_create_new_info + '"><i class="fas fa-plus-circle"></i> ' + lang.postback_html_label_create_new + '</span>' +
        '</div>' + 
        '<select id="reference-choose-label" class="form-control select2" multiple="">' +
        '</select>' +
      '</div>' +

      '<div class="form-group text-left mt-3 d-none">' +
        '<label for="reference-choose-sequence">' + lang.postback_html_label_sequence + '</label>' +
        '<select id="reference-choose-sequence" class="form-control select2">' +
        '</select>' +
      '</div>'
      ,

    willOpen: () => {
      var page_table_id = window.xitFlowBuilderData.page_table_id
      var base_url = window.xitFlowBuilderData.base_url
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

      const labelSelect = $('#reference-choose-label')

      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content'),
      })

      createSelect2DynamicOption(labelSelect)

      if (isSequenceAddonAvailable) {
        showElementsIfActionButtonHasSpecificValues(node)
      }

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_label_sequence_dropdown',
        dataType: 'JSON',
        data: { page_table_id, requested_from: 'reference', instagram_bot_addon },
        success:function(response){
          $("#reference-choose-label").html(response.label_dropdown);
          $("#reference-choose-sequence").html(response.drip_dropdown);

          $('#reference-choose-label').val(oldData.labelIds || '').trigger('change')
          $('#reference-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
        }
      })

      // Sets old data if there is any
      $('#reference-reference-postback').val(oldData.title || '')
      $('#reference-choose-label').val(oldData.labelIds || '').trigger('change')
      
      if (isSequenceAddonAvailable) {
        $('#reference-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
  
        $('#reference-choose-sequence').on('change', function() {
          Swal.resetValidationMessage()
          const currentValue = $(this).val()
          if ('newSequence' === oldData.sequenceIdValue && 'newSequence' !== currentValue) {
            node.referenceNodeNewSequenceValueChangeStatus = true;
            Swal.showValidationMessage(lang.postback_new_html_info_sequence)
          }
        })
      }      

      $('[data-toggle="tooltip"]').tooltip()
    },

    preConfirm: () => {
      const title = $('#reference-reference-postback').val()

      const labelIds = $('#reference-choose-label').val()
      const labelIdTexts = $('#reference-choose-label option:selected')
      const labelIdTextsArray = selectedOptionsTextArray(labelIdTexts)
      
      const sequenceIdValue = $('#reference-choose-sequence').val()
      const sequenceIdText = $('#reference-choose-sequence option:selected').text()
      
      if (! title) {
        Swal.showValidationMessage(lang.postback_modal_msg_title)
      }

      return {
        title, 
        labelIds,
        labelIdTextsArray, 
        sequenceIdValue,
        sequenceIdText,
      }
    },
  })
}

const showElementsIfActionButtonHasSpecificValues = (node) => {
  const connections = getNodeInputConnectionsBySocketName(CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON, node)
  if (connections[0]) {
    const nodeConnectedAsOutput = connections[0].output.node
    if (nodeConnectedAsOutput.name === CONST_COMPONENT.ACTION_BUTTON) {
      if (('get-started' === nodeConnectedAsOutput.data.actionType) 
        || ('messenger_engagement_plugin' === nodeConnectedAsOutput.data.actionType)
      ) {
        $('#reference-choose-sequence').parent().removeClass('d-none').addClass('d-block')
      }
    }
  }
}